<template>
	<div v-if="serverBusy">
		<div class="center-content">
			<input
				type="checkbox"
				id="terms-and-conditions"
				name="terms-and-conditions"
				title="Terms And Conditions"
				v-model="termsAndConditions"
			/>
			<label for="termsAndConditions" title="Terms And Conditions" class="terms-and-conditions-font">{{ languageStrings.checkingBoxAgreeTerms }}<a @click="getTermsAndConditions()" class="center-content" style="color: white; margin-bottom: 1%; font-size: xx-small;">{{ languageStrings.termsAndConditions }}</a></label>
			<div v-if="showTermsAndConditions">
				<TermsAndConditions
					:playerState="playerState"
					:languageStrings="languageStrings"
					:languageErrorStrings="languageErrorStrings"
					:tosContent="tosContent"
					:latestVersion="latestVersion"
					:showAcceptAndContinue="false"
				/>
			</div>
		</div>	
		<div class="button-container" :class ="restrictedNeedsMoreInfo&&
							fromPlayerCashCOC  >=  webPayOptions.taxAmlRestrictions.buyInThresholdCOC || !termsAndConditions || fromPlayerCashCOC > playerLimit  ? 'disable-container' : ''">
			<button class="btn buy-in-btn curved-border" :disabled="restrictedNeedsMoreInfo &&
							fromPlayerCashCOC  >=  webPayOptions.taxAmlRestrictions.buyInThresholdCOC || !termsAndConditions || fromPlayerCashCOC > playerLimit " :id="`commit-offer${buyInOffer.id}`" @click="order()">
				{{ languageStrings.commitTransaction }}
			</button>
		</div>
	</div>
</template>

<script>
import sharedScripts from "@/dependencies/sharedScripts";
import { onBeforeUnmount } from "vue";
import router from "@/router";
import TermsAndConditions from "@/components/TermsAndConditions";

export default {
	//Conekta was bought out and is now called DigitalFemsa
	//behind the scenes we are still calling it Conekta for requests
	//but it is actually DigitalFemsa that we are working with
	name: "Conekta",
	props: {
		playerState: Object,
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
		webPayOptions: Object,
		isMobile: Boolean,
		buyInOffer: Object,
		fromPlayerCashCOC: Number,
		restrictedNeedsMoreInfo: Boolean,
		provider: String,
		paymentMethodCode: String,
		playerLimit: Number,
	},
	components: {
		TermsAndConditions
	},
	data() {
		return {
			activeSession: this.session.get(),
			status: Object.assign({}, this.globalStatus),
			currencyInfo: this.playerState.currencyInfo,
			systemCurrencyInfo: this.systemCurrencyTool.currencyInfo,
			minorOrFull: this.systemCurrencyTool.displayType.minorOrFull,
			provider: "",
			statuses: [
				"failedAuthentication",
				"buyInAmountEmpty",
				"valueIsNotANumber",
				"meetMinimumBuyInAmount",
				"exceededMaximumBuyInAmount",
				"completeNeoCheck",
				"IdCheckRequired",
				"EmailNotVerified",
				"fetchStatusGood",
				"webPayIniateFailed",
				"Success",
				"tenMinimumForBuyIn"
			],
			serverBusy: false,
			tosContent:"",
			latestVersion: {},
			termsAndConditions: false,
			showTermsAndConditions: false,
		};
	},
	watch: {},
	created() {
		this.eventBus.on("closeTos", () => {
			this.showTermsAndConditions = false;
		});
	},
	mounted() {},
	methods: {
		async order() {
			this.serverBusy = true;
			this.busyText = this.languageStrings.initiatingBuyIn;

			let hasErrors = false;
			this.eventBus.emit("checkForSpamRequest");

			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				//failedAuthentication
				return this.handleStatusMessage(this.statuses[0]);
			}
			//buyInAmountEmpty
			if (!this.fromPlayerCashCOC){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[1]);
			}


			//valueIsNotANumber
			if (isNaN(this.fromPlayerCashCOC)){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[2]);
			}


			//meetMinimumBuyInAmount
			if (this.fromPlayerCashCOC < this.webPayOptions.conekta.buyInMinimumCOC){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[3]);
			}


			//exceededMaximumBuyInAmount
			if (this.fromPlayerCashCOC > this.buyInOffer.maximumCOC){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[4]);
			}
			

			//tenMinimumForBuyIn
			if (this.provider === "conekta" && this.fromPlayerCashCOC < 10){
				this.serverBusy = false;
				return this.handleStatusMessage(this.statuses[11]);
			}


			if (
				this.fromPlayerCashCOC > this.webPayOptions.taxAmlRestrictions.buyInThresholdCOC &&
				this.webPayOptions.taxAmlRestrictions.idCheckNeeded
			) {
				this.serverBusy = false;
				this.busyText = "";
				this.status.ok = false;
				this.status.message = `${this.systemCurrencyTool.formatCurrency(
					this.webPayOptions.taxAmlRestrictions.buyInThresholdCOC,
					this.systemCurrencyTool.displayType.full
				)} ${
					this.languageErrorStrings
						.completeNeoCheckIdVerification
				}.`;
				this.eventBus.emit("updateStatus", this.status);
				router.push("/identificationStatus");
				return false;
			}

			if (hasErrors === true) return;
			//DigitialFemsa is the the company that bought out Conekta, but all of our end still calls it by Conekta
			//For now all of the code stays the same when it comes to the request so far
			let body = {
				casinoId: this.webPayOptions.casino.id,
				buyInOfferId: this.buyInOffer.id,
				fromPlayerCashCOC: this.fromPlayerCashCOC,
				provider: "Conekta",
			};
			let requestUrl = new URL("/api/v1/webpay/buyin/initiate", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.playerState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				const response = await fetch(request);
				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);
				if (fetchStatus && !fetchStatus.ok) {
					this.eventBus.emit("updateStatus", fetchStatus);
					this.serverBusy = false;
					if (fetchStatus.forceLogout === true) this.eventBus.emit("forceLogout");
					return;
				}

				this.transaction = await response.json();

				if (this.transaction?.status === this.statuses[7]) {
					console.error(this.transaction?.status);
					this.serverBusy = false;
					//EmailNotVerified
					this.handleStatusMessage(this.statuses[7]);
					return;
				}
				//fetchStatusGood
				if (fetchStatus.ok) this.handleStatusMessage(this.statuses[8], null, this.transaction);

				if (this.status.ok) {
					this.performConektaCheckout();
					this.handleStatusMessage(this.statuses[10]);
				}
				this.serverBusy = false;
			} catch (e) {
				//webPayIniateFailed
				this.handleStatusMessage(this.statuses[9]);
				console.error(e);
			}
		},
		handleStatusMessage(causeOfMessage, maxCOC = null, transaction = null){
			this.serverBusy = false;
			this.busyText = "";

			//failedAuthentication
			if(causeOfMessage === this.statuses[0]) return false;

			this.status.ok = false;
			if(causeOfMessage === this.statuses[8]){
				//fetchStatusGood
				this.status = sharedScripts.checkSuccessErrors(transaction.status, this.languageErrorStrings);
				this.eventBus.emit("updateStatus", this.status);
			}
			else{
				this.status.message = sharedScripts.statusMessage(causeOfMessage, this.languageErrorStrings, this.systemCurrencyInfo, maxCOC);
				this.eventBus.emit("updateStatus", this.status);
			}
			 
			return false;
		},
		performConektaCheckout() {
			// Options copied from example code.
			const options = {
				backgroundMode: "lightMode", //lightMode o darkMode
				colorPrimary: "#081133", //botones y bordes
				colorText: "#585987", // títulos
				colorLabel: "#585987", // input labels
				inputType: "minimalMode", // minimalMode o flatMode
			};
			
			// this is not actually conekta but digitalFemsa, but we are keeping the naming the same
			const config = {
				locale: "en",
				// locale: this.countryCode === "MX" ? "es" : "en",
				publicKey: this.webPayOptions.conekta.apiKeyPublic,
				targetIFrame: "#conekta-checkout-element",
				checkoutRequestId: this.transaction.sessionId,
			};
			const callbacks = {
				onGetInfoSuccess: this.handleGetInfo,
				onFinalizePayment: this.handleFinalizePayment,
				onErrorPayment: this.handlePaymentError,
			};
			window.DigitalFemsaCheckoutComponents.Integration({
				config,
				callbacks,
				options,
			});
		},
		handleGetInfo(loadingTime) {
			this.eventBus.emit("showConektaWidgit", true);
		},
		async handleFinalizePayment(order) {
			await updateRfTranSatus("WaitingForProviderConfirmation");
			// this.eventBus.emit("showConektaWidgit", false);
			this.status.ok = true;
			this.status.message = this.languageErrorStrings.success;
			this.eventBus.emit("updateStatus", this.status);
			this.eventBus.emit("conektaCheckoutResult", order);
		},
		handlePaymentError(error) {
			this.status.ok = false;
			this.status.message = error;
			this.eventBus.emit("updateStatus", this.status);
			// this.eventBus.emit("showConektaWidgit", false);
		},
		async updateRfTranSatus(newStatus) {
			// Check if session needs to be refreshed
			let success = await this.authenticationCheck(this);
			if (success.hasOwnProperty("ok") && !success.ok) {
				this.serverBusy = false;
				this.busyText = "";
				return false;
			}

			let body = {
				webTranId: this.transaction.transaction.id,
				newStatus: newStatus,
			};

			let requestUrl = new URL("/api/v1/webpay/transaction/update", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.playerState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				const response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);

				if (fetchStatus && !fetchStatus.ok) {
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout === true) this.eventBus.emit("forceLogout");
					return;
				}

				let rfRequestStatus = await response.json();

				if (fetchStatus.ok)
					this.status = sharedScripts.checkSuccessErrors(this.transaction.status, this.languageErrorStrings);

			} catch (e) {
				//webPayIniateFailed
				this.handleStatusMessage(this.statuses[9]);
				console.error(e);
			}
		},
		getTermsAndConditions() {
			this.getLatestTosDocument();
		
		},
		async getLatestTosDocument() {
			this.serverBusy = true;
			this.busyText = this.languageStrings.loadingTermsAndConditions;
			// this.tosList = "testing test";
			// this.tosContent = "done testing";
			// console.log("this si the tos list", this.tosList);
			//here for testing purposes
			
			try {
				this.tosList = await this.listDocuments(this,"tos", 10);
				if (!this.tosList?.length > 0) {
					this.serverBusy = false;
					this.busyText = "";
					this.status.message = "There are no tos files avaliable";
					this.status.ok = false;
					this.eventBus.emit("updateStatus", this.status);
					return;
				}
				this.latestVersion = this.compareDocumentVersions(this.tosList);

				let documentUrl =
					this.latestVersion.url.indexOf("http") === 0
						? this.latestVersion.url
						: `./${this.latestVersion.url}`;

				let content = await fetch(documentUrl);
				let dataJson = await content.text();
				this.tosContent = this.removeScriptTag(dataJson);
				this.showTermsAndConditions = true;

				this.serverBusy = false;
				this.busyText = "";
			} catch (e) {
				console.error(e);
				this.serverBusy = false;
				this.busyText = "";
				this.status.ok = false;
				this.status.message = e;
				this.eventBus.emit("updateStatus", this.status);
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buy-in-btn {
	width: 100%;
	height: 100%;
	margin: 0;
}

button.btn:disabled {
	background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(19, 1, 1, 0.3)) !important;
	color: light-dark(rgba(16, 16, 16, 0.3), rgba(255, 255, 255, 0.3)) !important;
	border-color: light-dark(rgba(118, 118, 118, 0.3), rgba(195, 195, 195, 0.3)) !important;
}

.disable-container {
	opacity: .9 !important;
}

a:hover {
	cursor: pointer;
}

a {
	text-decoration: underline;
}
</style>
